/* eslint-disable react/require-default-props */

import React, { PropsWithChildren, useEffect, useRef } from "react";

import modal, { nextUID } from "../../redux/reducers/modal.reducer";
import { useTypedDispatch } from "../../redux/store";

import {
	removeModalContent,
	setModalContent,
} from "./modalContentStore";

export interface ModalProps extends PropsWithChildren {
	dimmer?: boolean | string;
	onDimmerClick?: () => void;
}

const Modal: React.FC<ModalProps> = ({ dimmer, children, onDimmerClick }) => {
	const dispatch = useTypedDispatch();
	const uidRef = useRef(nextUID());

	useEffect(() => {
		setModalContent(uidRef.current, {
			content: children,
			onDimmerClick,
		});
	}, [children, onDimmerClick]);

	useEffect(() => {
		const uid = uidRef.current;

		setModalContent(uid, { content: children, onDimmerClick });
		dispatch(modal.actions.pushWindow({ type: "window", uid, dimmer }));

		return () => {
			dispatch(modal.actions.removeWindow(uid));
			removeModalContent(uid);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		dispatch(
			modal.actions.editWindow({
				type: "window",
				uid: uidRef.current,
				dimmer,
			}),
		);
	}, [dimmer, dispatch]);

	// eslint-disable-next-line react/jsx-no-useless-fragment
	return <></>;
};

export default Modal;
